<nf-table-properties
  class="distributions-table-properties"
  [currentProperties]="currentProperties"
  [isOpen]="true"
>
  <div
    class="security-description-container d-flex"
    *ngIf="securityDescription"
  >
    <div
      class="security-description ellipsis"
      placement="bottom"
      [ngbTooltip]="securityDescription"
    >
      {{ securityDescription }}
    </div>
  </div>
</nf-table-properties>
